import { useEffect, useState } from "react";
import { Button, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Popup from "../../common/modal/Popup";
const ShowWardUrlPopup = ({wardLink, onHide, wardLinkModalShow, setWardLinkModalShow}) => {
const [copied, setCopied] = useState(false);
const {
   adminDetail
} = useSelector(state => state.admin);
const submitHandler = (mode) => {
    setWardLinkModalShow(false)
    onHide()
    
}


return (
    <>
        <Popup
            onHide={() => onHide()}
            size="md"
            show={wardLinkModalShow}
            title={"Ward Url"}
            footer={
                <>
                    <Button variant="outline-primary" onClick={(e) => submitHandler()}>Close</Button>
                    {/* //<Button className='btn-primary' onClick={(e) => submitHandler()}>Confirm</Button> */}
                </>
            }
        >
            
        <div className="bg-light p-4 rounded mb-4">
            <div className="publicUrlTitle">Url:</div>
            <div className="publicUrl ow">{`https://ccdguides.com/client/${adminDetail?.clientShortName}/${wardLink}`}</div>
        </div>
        <CopyToClipboard text={`https://ccdguides.com/client/${adminDetail?.clientShortName}/${wardLink}`} onCopy={() => setCopied({copied: true})}>
            <div style={{textAlign: "center"}}>
                <Button className='btn-primary'>Copy Url</Button>
            </div>
        </CopyToClipboard>
        <div className="pt-4" style={{textAlign: "center"}}>
            <p>{copied? <span style={{color: 'green'}}>Copied.</span> : null}</p>
        </div>
            
        </Popup>
        
    </>
)
}

export default ShowWardUrlPopup;